import type { TvChannel } from '@setplex/tria-api'
import type { CategoryType, TvCategoryEx } from '~/entities/epg/categories'

import { A } from '@mobily/ts-belt'
import { isType } from '~/entities/epg/categories'

/**
 * Checks if made-up category should be added to the list of categories
 */
export const shouldAdd = (
  type: CategoryType,
  categories: TvCategoryEx[],
  got?: readonly TvChannel[]
) => {
  const hasCategory = A.filter(categories, isType(type)).length > 0
  if (hasCategory) return false // made-up category already added

  const hasChannels = got != null && got.length > 0
  return hasChannels
}
